import { DateTime } from 'luxon';
import { FC } from 'react';
import styled from 'styled-components';

import { Td } from '@/components/Table';
import useUser from '@/hooks/useUser';
import { FreelancerInvoiceSubmissionResource } from '@/types/resources';

import FreelancerInvoiceRowActions from './FreelancerInvoiceRowActions';
import InvoiceAmountCells from './InvoiceAmountCells';
import InvoiceFileCell from './InvoiceFileCell';
import InvoicesStatusDot from './InvoicesStatusDot';

const GrayTd = styled(Td)`
  color: ${({ theme }) => theme.colors.gray};
`;

const CompanyTd = styled(Td)`
  white-space: nowrap;
`;

const StatusTd = styled(Td)`
  position: sticky;
  box-shadow: -1px 0 0 ${({ theme }) => theme.colors.grayscale};
  background: ${({ theme }) => theme.colors.white};
  right: 56px;
  top: 0;
  bottom: 0;
  z-index: 1;
`;

interface Props {
  submission: FreelancerInvoiceSubmissionResource;
}

const FreelancerInvoicesTableRow: FC<Props> = ({ submission }) => {
  // These are the freelancer's own submissions, so the seller is the user.
  const freelancer = useUser()?.freelancer;

  return (
    <tr>
      <GrayTd>
        {DateTime.fromISO(submission.createdAt).toFormat('yyyy/LL/dd')}
      </GrayTd>
      <CompanyTd>{submission.company?.name ?? '-'}</CompanyTd>
      <Td>{submission.hours ?? '-'}</Td>
      <InvoiceAmountCells submission={submission} />
      <Td>{submission.comment ?? '-'}</Td>
      <Td>{submission.invoice?.invoice_number ?? '-'}</Td>
      <Td>{submission.paymentPurpose}</Td>
      <InvoiceFileCell submission={submission} freelancer={freelancer} />
      <StatusTd>
        <InvoicesStatusDot status={submission.status} />
      </StatusTd>
      <Td $actionsCol>
        <FreelancerInvoiceRowActions submission={submission} />
      </Td>
    </tr>
  );
};

export default FreelancerInvoicesTableRow;
